import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import styles from './page-content.module.css';

type PageContentProps = {
  children: ReactNode | ReactNode[];
  style?: React.CSSProperties;
};

export const PageContent = observer(({ children, style }: PageContentProps) => {
  return (
    <div className={styles.container} style={style}>
      {children}
    </div>
  );
});
